<template>
  <div id="app" class="d-flex flex-fill">
    <loading :active.sync="isLoading" :is-full-page="true">
      <b-spinner
        style="width:5rem;height:5rem;color:#4b80b6 !important;"
        type="grow"
        label="Loading..."
        variant="info"
      ></b-spinner>
    </loading>
    <component :is="layout">
	  <PopupCampaign></PopupCampaign>
      <div v-if="isIdle"></div>
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </component>
  </div>
</template>

<script>

import { mapGetters } from "vuex";
import "vue-loading-overlay/dist/vue-loading.css";
import "element-ui/lib/theme-chalk/index.css";

const default_layout = "default";


export default {
  components: {
    loading: () => import("vue-loading-overlay"),
	PopupCampaign: () => import("./views/PopupCampaign.vue")
  },
  computed: {
    ...mapGetters(["isLoading", "getKlinikId"]),
    layout() {
      return (this.$route.meta.layout || default_layout) + "-layout";
    },
    auth_error() {
      return this.$store.state.autherror;
    },
    isIdle() {
      this.$store.state.idleVue.isIdle ? this.setIdle() : null;
			return this.$store.state.idleVue.isIdle;
		}
  },
  methods: {
    showAuthError() {
      this.$swal({
        allowOutsideClick: false,
        type: "warning",
        text: this.$store.state.autherror
      }).then(e => {
        this.$store.commit("SET_BEARER_TOKEN", null);
        this.$store.commit("SET_USER", null);
        this.$store.commit("SET_AUTHERROR", null);
        this.$router.push("/login");
      });
    },
    showUnauthorized() {
      this.$swal({
        allowOutsideClick: false,
        type: "warning",
        text: 'Unauthorized'
      }).then(e => {
        if (this.$store.state.autherror) {
          this.$store.commit("SET_BEARER_TOKEN", null);
          this.$store.commit("SET_USER", null);
          this.$store.commit("SET_AUTHERROR", null);
          this.$router.push("/login");
          return;
        }

        this.$store.commit("SET_AUTHERROR", null);
        this.setKlinik();
      });
    },
    initQiscusWebWidget() {
      window.qismoConfig = {
        extrasFields: [
          { name: "phone", placeholder: "Type your phone number", visible: true }
        ]
      };

      let getData = new URLSearchParams(window.location.search);
      let qdata = getData.get("chat");

      const callbacks = {
        roomChangedCallback() {
          QiscusSDK.core.sendComment(QiscusSDK.core.selected.id, qdata ? qdata : "izidok1");
        }
      };

      document.addEventListener('DOMContentLoaded', function() {
        var s,t; s = document.createElement('script'); s.type = 'text/javascript';
        s.src = 'https://s3-ap-southeast-1.amazonaws.com/qiscus-sdk/public/qismo/qismo-v2.js'; s.async = true;
        s.onload = s.onreadystatechange = function() { new Qismo("takal-q3ucpqd1q3nrsbm", { callbacks }); }
        t = document.getElementsByTagName('script')[0]; t.parentNode.insertBefore(s, t);
      });
    },
    async setIdle() {
      if(localStorage.getItem("IDLE") != 1 && localStorage.getItem('PREVENT_IDLE') != 1){
        var currentUrl = window.location.pathname;

        this.$store.commit("SET_BEARER_TOKEN", null);
        this.$store.commit("SET_AUTHERROR", null);
        localStorage.setItem('IDLE', 1);
        localStorage.setItem('LAST_URL', currentUrl);

        let profile = this.$store.state.user.id
        const res = await this.$axios.get(`user/${profile}?klinik_id=${this.getKlinikId}`)
        localStorage.setItem('TIPE_FASKES', res.data.data.klinik.tipe_faskes)

        this.$router.push("/idle");
      }
    },
    async setKlinik() {
      try {
        const res = await this.$axios.post(`user/set-klinik`, {
            user_id: this.$store.state.user.id,
            klinik_id: this.getKlinikId
          }
        )
        const { status, data } = res.data;
        if(status) {
          this.$store.commit('SET_KLINIK_ID', this.getKlinikId)
          this.$store.commit('SET_ROLES', data.roles);
          window.location.href = '/'
        } else {
          this.$swal({
            text: `Reload unauthorized gagal!`,
            type: "warning"
          });
        }
      } catch (err) {
        this.$swal({
          text: `Reload unauthorized gagal!`,
          type: "warning"
        });
      }
    }
  },
  watch: {
    auth_error(newVal, oldVal) {
      if (newVal == 'Unauthorized') {
        this.showUnauthorized();
      }
      else if(newVal) {
        this.showAuthError();
      }
    }
  },
  mounted() {
    if (this.$store.state.autherror) {
      this.showAuthError();
    }


    if (!window.location.href.includes('/logout/bidan') && !window.location.href.includes('/logout/pharmanet') ) {
      const klinikUser = this.$store.state.klinikUser;
      
      if (!this.$store.state.autherror) {
        if(klinikUser && klinikUser[0].is_pharmanet == 1) {  
          window.location = process.env.VUE_APP_PHARMANET
          return
        }

        if(klinikUser && klinikUser[0].is_bidan == 1) {
          window.location = process.env.VUE_APP_BIDAN
          return
        }
      }
    }

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then(function() { console.log('Service Worker Registered'); });
    }
  }
};
</script>

<style lang="scss">
@import "assets/bamburgh.scss";

.vld-overlay {
  &.is-full-page {
    z-index: 1100;
  }
}

@media only screen and (max-width: 900px) {
  .vdatetime-popup {
    transform: scale(.8, .7) translate(-60%, -70%) !important;
  }
}

// Qiscus Web Widget
form.qismo-login-form__body.extras-form .qismo-input {
  margin-bottom: 22px;
}
form.qismo-login-form__body.extras-form .qismo-input #phone-field {
  border: 0;
  border-radius: 5px;
  padding: 10px 10px 10px 60px;
  width: 100%;
  box-shadow: 0 3px 17px rgba(0, 0, 0, 0.05);
  position: relative;
  z-index: 1;
}
.extras-form div:nth-child(5) {
  position: relative;
}
.extras-form div:nth-child(5):after {
  content: " ";
  width: 48px;
  height: 100%;
  background: rgba(255,206,0,0.2)
    url(https://cdn.glitch.com/e00614fe-0eb2-4e6d-a705-3e7a15ac461d%2Fphone.png?v=1584074412877) no-repeat
    13px 14px;
  background-size: 20px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  border-radius: 5px 0 0 5px;
}
.qcw-cs-container .qcw-trigger-btn{
  width:300px;
  height:200px;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  background-color: transparent !important;
  background-image:url(https://assets.merci.co.id/covid/cek-covid-gratis.jpg) !important;
  background-position: center !important;
  background-size: 100% !important;
  background-repeat: no-repeat !important;
}
.qcw-container .qcw-trigger-btn{
  width:300px;
  height:200px;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  background-color: transparent !important;
  background-image:url(https://assets.merci.co.id/covid/cek-covid-gratis.jpg) !important;
  background-position: center !important;
  background-size: 100% !important;
  background-repeat: no-repeat !important;
}
.qcw-trigger-btn div, .qcw-trigger-btn img{
  display:none !important;
}
@media only screen and (min-width: 1750px) {
  .swal2-icon {
    font-size: 1.5em !important;
  }
  .swal2-confirm {
    margin-top: 15px !important;
  }
}
</style>

<style>
.vs--disabled .vs__clear,
.vs--disabled .vs__dropdown-toggle,
.vs--disabled .vs__open-indicator,
.vs--disabled .vs__search,
.vs--disabled .vs__selected {
  cursor:not-allowed !important;
  background-color:#eeeff8 !important;
}
</style>
